import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../store'
import axios from 'axios'
import Api from '../api/index'
import Swiper from 'swiper'
import QRCode from 'qrcode'
import { util } from '../assets/js/util'
import { data } from '../assets/js/data'
import '../assets/css/base.css'
import 'swiper/dist/css/swiper.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import vuescroll from 'vuescroll/dist/vuescroll-native'
Vue.use(vuescroll, {
  ops: {
    bar: {
      onlyShowBarOnScroll: false,
      background: '#ffffff',
      size: '4px'
    }
  } // 在这里设置全局默认配置
})

Vue.use(Api)
Vue.use(VueAwesomeSwiper)
Vue.prototype.util = util
Vue.prototype.pluginData = data
Vue.prototype.axios = axios
Vue.config.productionTip = false
window.Swiper = Swiper
window.QRCode = QRCode

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
